import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../utils/redux/hooks";
import { addisLoading } from "../../utils/redux/mainSlice";
import Scrollbar from "../../components/scrollbar";
import Loader from "../../components/Loader";
import EmptyState from "../../components/helpers/emptyState";

const DeclinedIDCheck = () => {
  const [businesss, setBusinesss] = useState([]);
  const [business, setBusiness] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useAppDispatch();

  const itemsPerPage = 25;
  const totalItems = (businesss as any)?.totalRecords;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const itemsToShow = business?.slice(startIndex, endIndex);

  const filteredFreelancers =
    searchTerm.length > 0
      ? itemsToShow.filter(
          (item: any) =>
            item?.firstName
              ?.toLowerCase()
              ?.includes(searchTerm.toLowerCase()) ||
            item?.lastName?.toLowerCase()?.includes(searchTerm.toLowerCase())
        )
      : itemsToShow;

  useEffect(() => {
    const fetchDeclinedBrands = async () => {
      try {
        dispatch(addisLoading(true));
        const AuthToken = await localStorage.getItem("AuthToken");
        const res = await axios({
          method: "get",
          url: "https://api.pureworker.com/api/admin/pending-verifications?status=rejected",
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        });
        const declined = (res as any)?.data?.data?.results;
        setBusinesss((res as any)?.data?.data);
        setBusiness(declined || []);
      } catch (err) {
        console.log(err);
      } finally {
        dispatch(addisLoading(false));
      }
    };
    fetchDeclinedBrands();
  }, []);

  const handleNextPageClick = async () => {
    if ((businesss as any)?.nextPageUrl) {
      dispatch(addisLoading(true));
      const AuthToken = await localStorage.getItem("AuthToken");
      try {
        const res = await axios({
          method: "get",
          url: (businesss as any)?.nextPageUrl,
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        });
        setBusinesss(res?.data?.data);
        setBusiness(res?.data?.data?.results);
      } catch (error) {
        console.log(error);
      }
      dispatch(addisLoading(false));
    }
  };

  const handlePrevPageClick = async () => {
    if ((businesss as any)?.prevPageUrl) {
      dispatch(addisLoading(true));
      const AuthToken = await localStorage.getItem("AuthToken");
      try {
        const res = await axios({
          method: "get",
          url: (businesss as any)?.prevPageUrl,
          headers: {
            Authorization: `Bearer ${AuthToken}`,
          },
        });
        setBusinesss(res?.data?.data);
        setBusiness(res?.data?.data?.results);
      } catch (error) {
        console.log(error);
      }
      dispatch(addisLoading(false));
    }
  };

  return (
    <>
      <div className="mb-4">
        <div className="ml-10 flex items-center sm:flex ">
          <FaSearch className="text-[#88087B]" />
          <input
            type="text"
            className=" rounded-full ml-4 px-4 py-2 sm:w-48 lg:w-70 font-roboto text-sm font-normal leading-5 tracking-tighter text-[#8E8E93] focus:outline-none"
            placeholder="Search Freelancers"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      {business?.length < 1 && (
        <EmptyState
          title={"No Approved Requests"}
          text={"Your approved verification requests would be displayed here."}
        />
      )}
      {business?.length > 0 && (
        <div className="">
          <section className="">
            <div className="overflow-x-auto rounded-t-lg">
              <table className="w-full">
                <thead className="bg-[#88087B] text-[#F7F7F7] font-roboto text-md font-medium">
                  <tr>
                    <th className="py-3 px-4">Business Name</th>
                    <th className="py-3 px-4">Phone Number</th>
                    <th className="py-3 px-4">Email</th>
                    <th className="py-3 px-4">Type</th>
                    <th className="py-3 px-4">Number</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredFreelancers.map((item: any) => (
                    <tr
                      key={item.id}
                      className="hover:bg-[#87878d] transition duration-300 font-roboto text-xs font-medium leading-normal text-center"
                    >
                      <td className="py-2 px-4">
                        {item?.user?.firstName
                          ? `${item?.user?.firstName} ${item?.user?.lastName}`
                          : item?.user?.businessName}
                      </td>
                      <td className="py-2 px-4">{item?.user?.phoneNumber}</td>
                      <td className="py-2 px-4">{item?.user?.email}</td>
                      <td className="py-2 px-4">{item?.type}</td>
                      <td className="py-2 px-4">{item?.number}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <Scrollbar
              currentPage={(businesss as any)?.currentPage}
              totalPages={Math.ceil(totalItems / itemsPerPage)}
              itemsPerPage={itemsPerPage}
              totalItems={totalItems}
              onPrevPageClick={handlePrevPageClick}
              onNextPageClick={handleNextPageClick}
            />
          </section>
        </div>
      )}
      {(businesss as any)?.loading && <Loader />}
    </>
  );
};

export default DeclinedIDCheck;
